import { useState } from "react";
/**
 *  Generates and returns an attribute with its own onChange callback.
 *  Useful for forms across the app
 * @param {*} initialValue the initial value of the field
 */
export function useFormInput(initialValue) {
  const [value, set] = useState(initialValue);

  // This is the event handler on change
  function handleValueChange(event) {
    set(event.target.value);
  }
  function setValue(val) {
    set(val);
  }

  return {
    // formProps is a convenience object to be simply spread in inputs
    // when spread in an input field, the field will get a value prop and an onChange callback prop
    formProps: { value, onChange: handleValueChange },

    // value is returned twice so you can simple write object.value instead of object.formProps.value
    value,
    setValue
  };
}



// WEBPACK FOOTER //
// ./src/hooks/generalHooks.js